import React from 'react';
import { useRecoilState } from 'recoil';
import { dimensionsAtom, TComplimentaryProductInfo } from 'pages/dimensions/store/dimensions';
import { complimentaryProductsState } from 'pages/calculation/store/calculation';
import { getIsCheckedProducts } from 'common/helpers/get-is-checked-products.helper';
import { SelectionGroupView } from './selection-group-view';
import { buildComplimentaryState, updateCheckedProducts } from './helpers';

type TProps = {
  variants: TComplimentaryProductInfo[];
  productId: string;
};

export const Variants = ({ variants, productId }: TProps) => {
  const [dimensionState, setDimensionState] = useRecoilState(dimensionsAtom);
  const { checkedProducts } = dimensionState;
  const [complimentaryProducts, setComplimentaryProducts] = useRecoilState(complimentaryProductsState);
  const selectedValue = complimentaryProducts[productId]?.isSelectedAsVariant ? productId : undefined;

  const handleChange = (variantProductId: string) => {
    const isProductChecked = getIsCheckedProducts({ checkedProducts, productId });
    const variant = variants.find(productVariant => productVariant.productId === variantProductId);

    if (!variant) {
      // eslint-disable-next-line no-console
      console.warn(`Variant product ${variantProductId} not found`);
      return;
    }

    if (variantProductId !== productId) {
      setDimensionState(prevState =>
        updateCheckedProducts({ prevState, variantProductId, productId, isProductChecked })
      );
    }

    setComplimentaryProducts(prevState => buildComplimentaryState({ prevState, productId, variant }));
  };

  /* ТУДУ: После того как будет решение по багу со скроллом, обраруженному в https://tracker.yandex.ru/PCP-13119,
     вернуть отображение Dropdown из
     https://github.lmru.tech/adeo/lmru--triffle--calculator/pull/107/commits/08580fdb1f8358fa4a4fea0aff4cd495e6d1bf5d#diff-b51e5a89cdac1ebeeb3983f3382735120447549ee596d8c0b535994b6c0e8c49R57
   */
  return <SelectionGroupView variants={variants} onChange={handleChange} selectedValue={selectedValue} />;
};
